const mobile = ".mobile-navigation-menu";
const desktop = ".desktop-navigation-menu";

/**
 * Open mobile menu.
 *
 * @return  {void}
 */
const openMenu = () => {
	$(".site-header").addClass("menu_opened");
	$("body").addClass("hidden");
	$(".main_header_menu").addClass("menu_opened");
	$(".mobile-header-js").removeClass("hidden");
};

/**
 * Close mobile menu.
 *
 * @return  {void}
 */
const closeMenu = () => {
	$(".site-header").removeClass("menu_opened");
	$("body").removeClass("hidden");
	$(".main_header_menu").removeClass("menu_opened submenu_opened");
	$(".mobile-header-js").addClass("hidden");
	$(`${mobile} .level3-menu, ${mobile} .level2-menu`).removeClass("opened");
	$(`${mobile} .level3-menu, ${mobile} .level2-menu, ${mobile} .navigation-items`).css("margin-left", "");
};

/**
 * Toggle submenu from mobile menu.
 *
 * @param   {object}  currentMenu DOMElement
 * @param   {object}  childmenu DOMElement
 *
 * @return  {void}
 */
const toggleMobileSubmenu = (currentMenu, childmenu) => {
	$(currentMenu).css("margin-left", "-100vw");
	$(".main_header_menu").addClass("submenu_opened");
	$(childmenu).addClass("opened");
};

/**
 * Show previously opened menu.
 *
 * @return  {void}
 */
const showPreviousMenu = () => {
	const currentOpenedMenu = $(`${mobile} ul.opened:last`);
	if ($(currentOpenedMenu).hasClass("level2-menu")) {
		//$(`${mobile} .navigation-items`).css("margin-left", "");
      $(`${mobile} .navigation-items`).animate({'margin-left': "unset"}, 50 , function () {
         $(currentOpenedMenu).removeClass("opened");
         $(".main_header_menu").removeClass("submenu_opened");
      })

      
	}
	if ($(currentOpenedMenu).hasClass("level3-menu")) {
     $(`${mobile} .level2-menu.opened`).animate({'margin-left': "unset"}, 50 , function () {
        $(currentOpenedMenu).removeClass("opened");
     })
// 		$(`${mobile} .level2-menu.opened`).css("margin-left", "");
//             	$(currentOpenedMenu).removeClass("opened");

	}
};

/**
 * Toggle desktop menu.
 *
 * @return  {void}
 */
const toggleMenu = () => {
	$(`${desktop} .level3-menu, ${desktop} .level2-menu, ${desktop} .navigation-menu`).css("left", "null");

	if (!$(`${desktop} .navigation-menu`).hasClass("hidden")) {
		$(`${desktop} .level3-menu, ${desktop} .level2-menu, ${desktop} .navigation-menu`).animate(
			{
				left: "-1000000",
			},
			600,
			function () {
				$(`${desktop} .level3-menu`).removeClass("opened");
				$(`${desktop} .level2-menu`).removeClass("opened");
				attachMouseEvents();
			}
		);
		$(`${desktop} .navigation-menu, ${desktop} .menu-overlay`).toggleClass("hidden");
	} else {
		$(`${desktop} .navigation-menu, ${desktop} .menu-overlay`).toggleClass("hidden");
		attachMouseEvents();
	}
	$(`${desktop} ul .close-menu`).removeClass("no_opacity");
};

/**
 * Toggle submenu from desktop menu
 *
 * @param   {void}  childmenu  DOMElement
 * @return  {void}
 */
const toggleSubmenu = (childmenu) => {
	if ($(childmenu).hasClass("level2-menu")) {
		$(`${desktop} .level3-menu.opened`).removeClass("opened");
		$(`${desktop} .level2-menu`).addClass("opened");
		$(`${desktop} .level2-menu`).css("opacity", "0");
		$(`${desktop} .level2-menu`).css("pointer-events", "none");
	} else {
		$(`${desktop} .level2-menu.opened`).length && $(`${desktop} .level3-menu`).addClass("opened");
		$(`${desktop} .level3-menu`).css("opacity", "0");
		$(`${desktop} .level3-menu`).css("pointer-events", "none");
	}

	$(childmenu).css("opacity", "1");
	$(childmenu).css("pointer-events", "all");

	$(`${desktop} ul .close-menu`).addClass("no_opacity");
	$(childmenu).find(".close-menu").removeClass("no_opacity");
};

/**
 * Attach desktop menu events.
 *
 * @return  {void}
 */
const attachMouseEvents = () => {
	$(`${desktop} .link.level2, ${desktop} .link.level3`).on("mouseover touchstart", function () {
		const id = $(this).data("id");
		return $(this).hasClass("level2")
			? toggleSubmenu($(`${desktop} .level2-menu[data-id='${id}']`))
			: toggleSubmenu($(`${desktop} .level3-menu[data-id='${id}']`));
	});

	$(`${desktop} .link-first:not(.level2)`).on("mouseover touchstart", function () {
		$(`${desktop} .level3-menu`).removeClass("opened");
		$(`${desktop} .level2-menu`).removeClass("opened");
		$(`${desktop} .navigation-items .close-menu`).removeClass("no_opacity");
	});

	$(`${desktop} .link-second:not(.level3)`).on("mouseover touchstart", function () {
		$(`${desktop} .level3-menu`).removeClass("opened");
		$(`${desktop} .level2-menu .close-menu`).removeClass("no_opacity");
	});
};

$(document).ready(function () {
	$(`${mobile} .link.level2 a, ${mobile} .link.level3 a`).attr("href", "#");

	$(`${mobile} .link.level2, ${mobile} .link.level3`).on("click", function (e) {
		e.preventDefault();
		const id = $(this).data("id");
		const currentMenu = $(this).closest("ul");
		return $(this).hasClass("level2")
			? toggleMobileSubmenu(currentMenu, $(`${mobile} .level2-menu[data-id='${id}']`))
			: toggleMobileSubmenu(currentMenu, $(`${mobile} .level3-menu[data-id='${id}']`));
	});

	$(".hamburger-menu-toggler, .close_mobile_menu").on("click", function (e) {
		e.preventDefault();
		return $(".mobile-header-js").hasClass("hidden") ? openMenu() : closeMenu();
	});

	$(".main_header_menu .previous-menu").on("click", () => showPreviousMenu());

	$(`${desktop} .close-menu, .toggle-menu-js, ${desktop} .menu-overlay`).on("click keyup", function (e) {
		if (e.type === "click" || (e.type === "keyup" && e.key === "Enter")) {
			$(`${desktop} .link.level2, ${desktop} .link.level3, ${desktop} .link-first, ${desktop} .link-second`).off("mouseover");
		}
		toggleMenu();
	});
});

